"use client";

import { useId, useState } from "react";

export default function FAQItem({
  question,
  answer,
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  const panelId = useId();

  return (
    <div>
      <h3 className="text-lg md:text-xl font-semibold">
        <button
          type="button"
          className="flex w-full justify-between items-center gap-4 text-left cursor-pointer"
          aria-expanded={isOpen}
          aria-controls={panelId}
          onClick={() => setIsOpen(!isOpen)}
        >
          <span>{question}</span>
          <svg
            className={`w-5 h-5 shrink-0 transition-transform ${
              isOpen ? "rotate-180" : ""
            }`}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <polyline points="6 9 12 15 18 9"></polyline>
          </svg>
        </button>
      </h3>
      <div
        id={panelId}
        className={`transition-all duration-300 ${
          isOpen ? "max-h-96 opacity-100 mt-3" : "max-h-0 opacity-0 overflow-hidden"
        }`}
      >
        <div className="text-gray-600">{answer}</div>
      </div>
    </div>
  );
}
